import * as keyapis_omnichat_v1_credentials_pb from "./v1/keyapis_omnichat_credentials_v1.pb";
import * as keyapis_omnichat_v1_omnichat_pb from "./v1/keyapis_omnichat_v1.pb";
import * as keyapis_omnichat_v1_system_pb from "./v1/keyapis_omnichat_system_v1.pb";

export default {
  v1: {
    resources: {
      credentials: keyapis_omnichat_v1_credentials_pb,
      omnichat: keyapis_omnichat_v1_omnichat_pb,
      system: keyapis_omnichat_v1_system_pb,
    },
  },
};
